import { HttpContextToken } from '@angular/common/http';

export const FORGOTTEN_PASSWORD_TOKEN = new HttpContextToken<string | null>(() => null);
